import { render, staticRenderFns } from "./AvatarsList.vue?vue&type=template&id=a80ab946&"
import script from "./AvatarsList.vue?vue&type=script&lang=js&"
export * from "./AvatarsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports